import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import InputControl from '../InputControl/InputControl';
import './FilterInput.scss';

const FilterInput = ({
  onTriggered,
  onDismiss,
}) => {
  const [filter, setFilter] = useState(undefined);
  return (
    <div className="filter-input">
      <InputControl
        placeholder="Search..."
        type="text"
        onValueChanged={(value) => {
          if (onTriggered) {
            onTriggered(value);
          }
          setFilter(value);
        }}
        value={filter}
        initialValue={filter}
        onKeyDown={(key) => {
          if (key.keyCode === 13) {
            onTriggered(filter);
          }
        }}
      />
      <button
        type="button"
        className="dismiss-button"
        onClick={() => {
          setFilter('');
          if (onDismiss) {
            onDismiss();
          }
        }}
      >
        <FontAwesomeIcon icon={solid('times')} />
      </button>
      <button
        type="button"
        className="filter-button"
        onClick={() => {
          if (onTriggered) {
            onTriggered(filter);
          }
        }}
      >
        <FontAwesomeIcon icon={solid('search')} />
      </button>
    </div>
  );
};

FilterInput.propTypes = {
  onTriggered: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default FilterInput;
